/** 
 *{
    type: { type: String, require: true, enum: ["benefits", "specializations", "cert"], description: "Тип  копії документа" },
    file:{
        name: { type: String, require: true, description:"найменування файлу" },
        mime: { type: String, require: true, description:"тип файла" },
        size: { type: Number, require: true, description:"розмір файлу"},
        datetimeupload: { type: Date, require: true, description:"дата завантаження"},
        date: { type: Date, require: true, description:"дата останніх змін файлу"},
        storage:{
            path:{ type: String, require: true, description:"відносний шлях збереження файлу" },
            name:{ type: String, require: true, description:"найменування файлу у сховищі" }
        },
        securuty:{
            ro:{ type: Boolean, require: true, description:"можливість перезапису"}
        }
    }
*/

// Функция для получения идентификатора файла
const getFileId = (file) => {
  return file && file._id ? file._id : null;
};

// Функция для получения метаданных файла для сравнения
const getFileMetadata = (file) => {
  if (!file) return null;
  
  return {
    name: file.name || (file.file && file.file.name),
    size: file.size || (file.file && file.file.size),
    type: file.type || (file.file && file.file.type) || (file.file && file.file.mime)
  };
};

// Функция для проверки, изменился ли файл
const isFileChanged = (newFile, originalFile) => {
  const newMetadata = getFileMetadata(newFile);
  const originalMetadata = getFileMetadata(originalFile);
  
  if (!newMetadata || !originalMetadata) return true;
  
  // Сравниваем по названию, размеру и типу
  return newMetadata.name !== originalMetadata.name ||
         newMetadata.size !== originalMetadata.size ||
         newMetadata.type !== originalMetadata.type;
};

// Функция для получения секции файла по типу
const getFileSection = (fileType) => {
  switch (fileType) {
    case 'cert':
      return 'cert';
    case 'benefits':
      return 'benefits';
    case 'specializations':
      return 'specializations';
    default:
      return 'other';
  }
};

export function getFiles(doc) {
  const { preferences, child, benefits } = doc;

  const out_info = {
    cert: child.birthCertificate.files || [],
    benefits: benefits.files || [],
    specializations: preferences.diseaseDocument.files || []
  };

  return out_info;
}

// Функция для определения файлов, которые нужно удалить
export function getFilesToDelete(newData, originalData) {
  const filesToDelete = [];
  
  // Сравниваем файлы свидетельства о рождении
  const newCertFiles = newData.child.birthCertificate.files || [];
  const originalCertFiles = originalData.child.birthCertificate.files || [];
  
  // Находим файлы, которые были в оригинале, но отсутствуют в новых данных
  originalCertFiles.forEach(originalFile => {
    const fileExistsInNew = newCertFiles.some(newFile => 
      getFileId(newFile) === getFileId(originalFile)
    );
    
    // Если файл был в оригинале, но его нет в новых данных - удаляем
    if (!fileExistsInNew && getFileId(originalFile)) {
      filesToDelete.push({
        fileId: getFileId(originalFile),
        section: getFileSection('cert'),
        fileData: originalFile // сохраняем данные файла для отладки
      });
    }
  });
  
  // Сравниваем файлы льгот
  const newBenefitsFiles = newData.benefits.files || [];
  const originalBenefitsFiles = originalData.benefits.files || [];
  
  originalBenefitsFiles.forEach(originalFile => {
    const fileExistsInNew = newBenefitsFiles.some(newFile => 
      getFileId(newFile) === getFileId(originalFile)
    );
    
    if (!fileExistsInNew && getFileId(originalFile)) {
      filesToDelete.push({
        fileId: getFileId(originalFile),
        section: getFileSection('benefits'),
        fileData: originalFile
      });
    }
  });
  
  // Сравниваем медицинские файлы
  const newMedicalFiles = newData.preferences.diseaseDocument.files || [];
  const originalMedicalFiles = originalData.preferences.diseaseDocument.files || [];
  
  originalMedicalFiles.forEach(originalFile => {
    const fileExistsInNew = newMedicalFiles.some(newFile => 
      getFileId(newFile) === getFileId(originalFile)
    );
    
    if (!fileExistsInNew && getFileId(originalFile)) {
      filesToDelete.push({
        fileId: getFileId(originalFile),
        section: getFileSection('specializations'),
        fileData: originalFile
      });
    }
  });
  
  console.log('Files to delete:', filesToDelete); // для отладки
  return filesToDelete;
}

// Функция для получения файлов, которые нужно загрузить (только измененные)
export const getFilesToUpload = (newData, originalData) => {
  const filesToUpload = {
    cert: [],
    benefits: [],
    specializations: []
  };
  
  // Сравниваем файлы свидетельства о рождении
  const newCertFiles = newData.child.birthCertificate.files || [];
  const originalCertFiles = originalData.child.birthCertificate.files || [];
  
  newCertFiles.forEach(newFile => {
    // Если это новый файл (без _id) или изменился существующий
    if (!getFileId(newFile) || 
        !originalCertFiles.some(originalFile => 
          getFileId(originalFile) === getFileId(newFile) && 
          !isFileChanged(newFile, originalFile)
        )) {
      filesToUpload.cert.push(newFile);
    }
  });
  
  // Сравниваем файлы льгот
  const newBenefitsFiles = newData.benefits.files || [];
  const originalBenefitsFiles = originalData.benefits.files || [];
  
  newBenefitsFiles.forEach(newFile => {
    if (!getFileId(newFile) || 
        !originalBenefitsFiles.some(originalFile => 
          getFileId(originalFile) === getFileId(newFile) && 
          !isFileChanged(newFile, originalFile)
        )) {
      filesToUpload.benefits.push(newFile);
    }
  });
  
  // Сравниваем медицинские файлы
  const newMedicalFiles = newData.preferences.diseaseDocument.files || [];
  const originalMedicalFiles = originalData.preferences.diseaseDocument.files || [];
  
  newMedicalFiles.forEach(newFile => {
    if (!getFileId(newFile) || 
        !originalMedicalFiles.some(originalFile => 
          getFileId(originalFile) === getFileId(newFile) && 
          !isFileChanged(newFile, originalFile)
        )) {
      filesToUpload.specializations.push(newFile);
    }
  });
  
  return filesToUpload;
};

export const debugFileStructures = (newData, originalData) => {
  console.log('=== FILE STRUCTURE DEBUG ===');
  console.log('Original cert files:', originalData.child.birthCertificate.files);
  console.log('New cert files:', newData.child.birthCertificate.files);
  console.log('Original benefits files:', originalData.benefits.files);
  console.log('New benefits files:', newData.benefits.files);
  console.log('Original medical files:', originalData.preferences.diseaseDocument.files);
  console.log('New medical files:', newData.preferences.diseaseDocument.files);
  console.log('============================');
};